var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524:902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34282 1.73428V0.816406H0.835571V6.32365H1.75345V2.3833L6.36252 6.99235L7.01152 6.34336L2.40247 1.73428H6.34282Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34282 1.8309H6.43943V1.73428V0.816406V0.719788H6.34282H0.835571H0.738953V0.816406V6.32365V6.42027H0.835571H1.75345H1.85006V6.32365V2.61656L6.2942 7.06067L6.36252 7.12899L6.43084 7.06067L7.07984 6.41168L7.14816 6.34336L7.07984 6.27504L2.63572 1.8309H6.34282Z",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 0.193237
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6858 9.07726V13.0176L8.96198 8.29382L8.31299 8.94282L13.0368 13.6666H9.09642V14.5845H14.6037V9.07726H13.6858Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6858 8.98064H13.5892V9.07726V12.7843L9.0303 8.2255L8.96198 8.15718L8.89366 8.2255L8.24467 8.8745L8.17635 8.94282L8.24467 9.01114L12.8035 13.57H9.09642H8.9998V13.6666V14.5845V14.6811H9.09642H14.6037H14.7003V14.5845V9.07726V8.98064H14.6037H13.6858Z",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 0.193237
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524:902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.686,
    height: 14.686,
    fill: "white",
    transform: "translate(0.376831 0.357422)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.ea3452202990808cd9eebc6b0a386961.svg";
export { ForwardRef as ReactComponent };